var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.6,
    height: 11,
    viewBox: "0 0 10.6 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-60 -564.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2987",
    transform: "translate(60 564.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2983",
    d: "M60.672,862.411h.847v-2.227h.672l-1.1-2.144L60,860.184h.672Z",
    transform: "translate(-60 -851.411)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2985",
    d: "M216.152,745.252H217v-5.068h.672l-1.1-2.144-1.1,2.144h.672Z",
    transform: "translate(-211.275 -734.252)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3035",
    d: "M371.631,589.036h.847V580.18h.672l-1.1-2.144-1.1,2.144h.672Z",
    transform: "translate(-362.55 -578.036)",
    fill: "var(--mainColor)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/directionIcon.71993a2614bf73e40fa7bcf39c0f04e5.svg";
export { ForwardRef as ReactComponent };